import { useDispatch } from 'react-redux';
import { roomUpdateApi } from '../api/myprojects';
import { MODEL_TYPES } from '../constants/constants';
import { paginatedRoomsSelectors } from '../redux/slicers/admin/paginatedRooms';
import { editRoomDetailsPopupActions } from '../redux/slicers/editRoomDetailsPopupSlicer';
import { useDownloadEntity } from "./useDownloadEntity";
import { useModelActions } from './useModelActions';

export const useTemplateActions = ({ item }) => {
  const dispatch = useDispatch()
  const { download3DFilesZip } = useDownloadEntity();
  const { favouriteLoading, onFavouriteToggle, onShare, addToCollection, requestTo3DFilesCollection } = useModelActions({
    item,
    modelType: MODEL_TYPES.ROOM,
    selectors: paginatedRoomsSelectors,
    updateApi: roomUpdateApi,
  });

  const onEditInfo = () => dispatch(editRoomDetailsPopupActions.show(item));

  return {
    favouriteLoading,
    onFavouriteToggle,
    onShare,
    addToCollection,
    onEditInfo,
    download3DFilesZip,
    requestTo3DFilesCollection,
  };
};


